export const TRIAL_USAGE_LOG_ENDPOINT = '/companies/trial/usage-log';
